import { DateTime } from "luxon";
import type { Call } from "@/lib/api/calls";
import type { Note } from "@/lib/api/notes";

export interface NoteFeedItem extends Note {
  type: "note";
}

export interface CallFeedItem extends Call {
  type: "call";
}

export type NoteOrCallLog = NoteFeedItem | CallFeedItem;

function feedItemMillis(item: NoteOrCallLog): number {
  const raw = item.type === "note" ? item.createdAt : item.created_at;
  const fromIso = DateTime.fromISO(raw);
  if (fromIso.isValid) return fromIso.toMillis();
  const fromSql = DateTime.fromSQL(raw, { setZone: true });
  return fromSql.isValid ? fromSql.toMillis() : 0;
}

export function mergeNotesAndCallLogs(
  notes: Note[],
  callLogs: Call[],
): NoteOrCallLog[] {
  const list: NoteOrCallLog[] = [
    ...notes.map((note) => ({ ...note, type: "note" as const })),
    ...callLogs.map((call) => ({ ...call, type: "call" as const })),
  ];

  return list.toSorted((a, b) => feedItemMillis(b) - feedItemMillis(a));
}
